import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/searchPage/actionTypes';

import { setSelectedVehicle } from './utils';

export default function* listenSetSelectedVehicle() {
  yield takeEvery(actionTypes.SET_SELECTED_VEHICLE, setSelectedVehicle);
}
